// extracted by css-extract-rspack-plugin
export default {"host":"InlineLottie-module__host"};